module.exports = __webpack_public_path__ + "img/conny-stage3-blink.edff7748.png";